/**
 * New customer accounts may trigger manual fraud verification.
 */
export const UndergoingVerification = () => (
  <div>
    <h3>You don&apos;t yet have access to Managed Google Cloud Platform</h3>
    <div>
      <p>
        Your account is currently undergoing verification and should be ready shortly.
        If you have any questions, please contact us at 877-417-4274 (US) or 0800-033-4045 (UK).
      </p>
    </div>
  </div>
);
